import React from 'react'
import { useTheme } from '../ThemeContext';

const Footer = () => {
    const { isDarkMode } = useTheme();

    return (
        <footer className={isDarkMode ? 'bg-slate-800 text-amber-100 mt-10 p-2 shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)]'
        : ' bg-amber-100 text-slate-800 mt-10 p-2 shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)]'}>
            <div className="container mx-auto text-center">
                <b>Email:</b> keebs.berkeley@gmail.com | <b>Instagram:</b> @keebs.berkeley
            </div>
        </footer>
    )
}

export default Footer